/**
 * Thrown when the user's session cannot produce a valid access token any more: no session
 * cookie, an unparsable one, a Cognito refresh that failed, or a backend that still answers
 * 401 after a forced refresh. The only way out is a new login.
 *
 * Lives in its own dependency-free module so both the token helper (utils/authToken) and the
 * fetch wrapper (api/portalsFetch) can import it without an import cycle, and so tests can
 * mock either of those modules while keeping this class identity intact.
 */
export class SessionExpiredError extends Error {
  constructor(message = 'Your session has expired') {
    super(message);
    this.name = 'SessionExpiredError';
  }
}
